import './_styles.scss'
import React from 'react'
import { IoIosArrowDown } from "react-icons/io"

export default function Sorting({ onChange }) {

  const [selected, select_option] = React.useState(0);

  const [show_options, toggle_options] = React.useState(false);

  const options = [
    'Alphabetically, A-Z',
    'Alphabetically, Z-A',
    'Price, low to high',
    'Price, high to low',
  ]

  const visibility = !!show_options ? 'menu-visible' : 'menu-hidden';

  const on_select_option = (option='',index=0) => {

    if (typeof(onChange)==='function') onChange(option);

    return select_option(index);

  }

  return (
    <div className={`sorting ${visibility}`} onClick={() => toggle_options(!show_options)}>

      <div className="label">Sort by: </div>

      <div className="selected">{options[selected]}</div>

      {(!!show_options) &&
        <div className="options">
          {
            options.map((a,i) =>
              <div key={a} className='option' onClick={() => on_select_option(a,i)}>
                {a}
              </div>
            )
          }
        </div>
      }


      <IoIosArrowDown className='icon' />

    </div>
  )
}
